import ClassicEditor from './form/ckeditor-config';

export default class Editor {

  constructor() {
    const editors = document.querySelectorAll('.wysiwyg');
    if (editors.length) {
      editors.forEach( editor => {
        this.initEditor( editor );
      });
    }
  }

  initEditor( elem ) {
    const uploadUrl = elem.dataset.simpleUploadUrl || null;

    ClassicEditor
      .create( elem, uploadUrl ? {
        simpleUpload: {
          uploadUrl,
        },
        link: {
          addTargetToExternalLinks: true,
        },
      } : undefined)
      .then( editor => {
        $(this).data('editor', editor);
        editor.ui.view.editable.element.style.height = elem.dataset.height ? `${elem.dataset.height}px` : '350px';
      })
      .catch( error => {
          console.error( error );
      });
  }
}
